// Check if we can replace with Object.keys(countryCodes.customList('officialLanguageCode'))
export const LANGUAGE_CODES = [
  'af',
  'ar',
  'sq',
  'eu',
  'be',
  'bg',
  'ca',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fo',
  'fa',
  'fi',
  'fr',
  'gd',
  'de',
  'el',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'ga',
  'it',
  'ja',
  'ko',
  'ko',
  'ku',
  'lv',
  'lt',
  'mk',
  'ml',
  'ms',
  'mt',
  'no',
  'nb',
  'nn',
  'pl',
  'pt',
  'pa',
  'rm',
  'ro',
  'ru',
  'sr',
  'sk',
  'sl',
  'es',
  'sv',
  'th',
  'tn',
  'tr',
  'uk',
  'ur',
  'vi',
  'cy',
  'xh',
  'ji',
  'zu',
  'zh',
];

export const PRO_LANGUAGE_CODES: Array<string> = ['fr', 'nl', 'en', 'es', 'it', 'de', 'rm'];
export const BREEDER_LANGUAGE_CODES: Array<string> = ['fr', 'nl', 'en', 'es', 'it', 'de', 'rm'];
